export default "__VITE_ASSET__utufxzLM__"